import { useState } from 'react';
import {
  useMessageHandlers,
  MessageHandlers,
} from '@client/components/hooks/chatpage-hooks/useMessageHandlers';
import { useMessagePositions } from '@client/components/hooks/chatpage-hooks/useMessagePositions';
import { Message, User, Character } from '@components'

interface ChatPageAPI extends MessageHandlers {
  isSettingsOpen: boolean;
  isAdModalOpen: boolean;
  setIsAdModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  toggleSettings: () => void;
}

export const useChatPageAPI = (
  previous_message: Message[],
  user: User,
  char: Character,
  chat_uuid: string,
  setIsGenerating: React.Dispatch<React.SetStateAction<boolean>>
): ChatPageAPI => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isAdModalOpen, setIsAdModalOpen] = useState(false);

  const toggleSettings = () => setIsSettingsOpen((prev) => !prev);

  useMessagePositions(chat_uuid);

  const messageHandlers = useMessageHandlers(
    previous_message,
    user,
    char,
    chat_uuid,
    setIsGenerating
  );

  return {
    isSettingsOpen,
    isAdModalOpen,
    setIsAdModalOpen,
    toggleSettings,
    ...messageHandlers,
  };
};
